import { Component, OnInit, HostListener } from '@angular/core';
import { environment } from '../../../environments/environment';
import { SesionvService } from '../core/services/sesionv.service';
import { CookieService } from 'ngx-cookie-service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'app-headerver',
    templateUrl: './headerver.component.html',
    styleUrls: ['./headerver.component.scss'],
    standalone: false
})

export class HeaderverComponent implements OnInit {
	scroll = false;
  url: any;
  loginUrl: string;
  regUrl: any;
  errorUrl = false;
  initial = false;
  user: any = null;
  isOpen = false;
  isOpen2 = false;

  cookieValue = null;

  constructor(public sesionv: SesionvService, private cookieService: CookieService, public router: Router) {
    this.loginUrl = environment.verifica.urlLogin;
    this.regUrl = environment.verifica.urlRegister;
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.url = val.url;
        if (val.url === '/error'){
          this.errorUrl = true;
        }
        if (val.url !== '/'){
          this.initial = true;
        } else {
          this.initial = false;
        }
      }
    });

    this.sesionv.getCookie();
    this.sesionv.validateSession();
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event:any) {
    if (this.url === '/'){
      if (window.pageYOffset !== 0) {
        this.scroll = true;
      } else {
        this.scroll = false;
      }
    }
  }

  ngOnInit() {

  }

  home() {
    this.router.navigate(['/']);
  }

  toggleClass() {
    this.isOpen = !this.isOpen;
  }

  toggleClass2() {
    this.isOpen2 = !this.isOpen2;
  }

  cerrarSession() {
    this.toggleClass();
    this.sesionv.closeSession();
  }
}	